// CMP-NetworkStatusBar (Lot 1b ; TRV-07). Module léger, chargé par la coquille.
import { Wifi, WifiOff } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/cn';
import { useOnlineStatus } from '@/lib/network';

/**
 * Statut réseau permanent : discret en ligne, visible hors ligne, message au retour du réseau.
 * N'affiche jamais « synchronisé » : la synchronisation (lot F5) aura ses propres états.
 */
export function NetworkStatusBar() {
  const { t } = useTranslation();
  const online = useOnlineStatus();
  const [justReconnected, setJustReconnected] = useState(false);
  const [wasOffline, setWasOffline] = useState(!online);

  useEffect(() => {
    if (!online) {
      setWasOffline(true);
      return;
    }
    if (wasOffline) {
      setJustReconnected(true);
      setWasOffline(false);
      const timer = window.setTimeout(() => setJustReconnected(false), 4000);
      return () => window.clearTimeout(timer);
    }
  }, [online, wasOffline]);

  if (online && !justReconnected) return null;

  return (
    <div
      role="status"
      className={cn('flex items-center justify-center gap-2 px-4 py-1.5 text-small font-semibold', online ? 'bg-success-bg text-success' : 'bg-warning-bg text-warning')}
    >
      {online ? <Wifi aria-hidden="true" className="size-4" /> : <WifiOff aria-hidden="true" className="size-4" />}
      {online ? t('network.back_online') : t('network.offline')}
    </div>
  );
}
